<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          &copy;{{ new Date().getFullYear() }} KGB Aviation, All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped lang="scss">
.footer {
  padding: $gutter 0;
  color: rgba(0, 0, 0, 0.5);
  border-top: $default-border;
}
</style>
